import Box from "@mui/material/Box"
import CircularProgress from "@mui/material/CircularProgress"

type LoaderProps = {
    colour?: string
}

const Loader = (props: LoaderProps) => {
    return (
        <Box sx={{width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <CircularProgress
                sx={props?.colour !== undefined ? {color: `${props.colour}`} : {color: "#101941"}}
                size="1.5rem"
            />
        </Box>
    )
}

export default Loader
